import community1 from '@/assets/community_1.jpg';
import community3 from '@/assets/community_3.jpg';
import family1 from '@/assets/family_1.jpg';
import family2 from '@/assets/family_2.jpg';
import family3 from '@/assets/family_3.jpg';
import family4 from '@/assets/family_4.jpg';
import family5 from '@/assets/family_5.jpg';
import family6 from '@/assets/family_6.jpg';

export interface KPI {
  label: string;
  value: string;
  icon: string; // Lucide icon name
}

export interface Project {
  name: string;
  description: string;
  kpis: KPI[];
}

export interface CareerStep {
  id: string;
  period: string;
  role: string;
  company: string;
  location?: string;
  developing: string;
  developmentArea?: string[];
  description: string;
  projects: string[] | Project[];
  category: 'education' | 'work' | 'personal' | 'publication';
  tileSpan?: number; // Manual override for tile size (number of 20px grid rows)
  imageUrl?: string | { src: string };
}

export const careerData: CareerStep[] = [
  /*  {
      id: "education-3",
      period: "1998 - 2007",
      role: "High School Student",
      company: "Uhlandgymnasium Tübingen",
      location: "Tübingen, Germany",
      developing: "Academic Foundation",
      developmentArea: ['competences'],
      description: "Allgemeine Hochschulreife (Final grade: 2.1)",
      projects: [],
      category: 'education',
      tileSpan: 4
    },
    */

  {
    id: "career-10",
    period: "06/2008 - 05/2009",
    role: "Work & Travel",
    company: "Canada, U.S.A., Mexico",
    location: "Various locations",
    developing: "Myself",
    developmentArea: ['competences'],
    description: "Canada, U.S.A., Mexico",
    projects: [],
    category: 'personal',
    tileSpan: 3
  },
  {
    id: "education-2",
    period: "2009 - 2013",
    role: "Engineering Student",
    company: "UAS Karlsruhe",
    location: "Karlsruhe, Germany",
    developing: "Technical Engineering Skills",
    developmentArea: ['competences'],
    description: "B.Eng. in Automotive Engineering (Final Grade: 1.4)",
    projects: [],
    category: 'education',
    tileSpan: 4
  },
  {
    id: "career-8",
    period: "10/2011 - 07/2013",
    role: "Working Student & Graduand",
    company: "Daimler AG, UAS Karlsruhe, Robert Bosch GmbH",
    location: "Böblingen, Karlsruhe, Bühl",
    developing: "Academic & Technical Skills",
    developmentArea: ['products'],
    description: "Multiple parallel roles during studies",
    projects: [
      "Graduand at Daimler AG: 'Hybrid Vehicle ICE Testing through E-Drive' (Grade: 1.0)",
      "Software engineering and Maths 3 tutor at UAS Karlsruhe",
      "Testing electric drives at Robert Bosch GmbH"
    ],
    category: 'education',
    tileSpan: 3
  },
  {
    id: "career-9",
    period: "03/2012 - 06/2012",
    role: "Intern",
    company: "Mercedes-Benz (Thailand) Ltd.",
    location: "Samut Prakan, Thailand",
    developing: "Quality Assurance Processes",
    developmentArea: ['products'],
    description: "Developed standardized end-of-line quality checks",
    projects: [],
    category: 'work',
    tileSpan: 4
  },
  {
    id: "publication-4",
    period: "2013",
    role: "Patent Inventor",
    company: "Daimler AG",
    location: "Germany",
    developing: "Innovation",
    developmentArea: ['products'],
    description: "Patent: 'Diagnoseverfahren für ein Kraftfahrzeug'",
    projects: [],
    category: 'publication',
    tileSpan: 4
  },
  {
    id: "career-7",
    period: "11/2013 - 06/2015",
    role: "Software Development Engineer",
    company: "ITK Engineering GmbH",
    location: "Rülzheim",
    developing: "Software Solutions",
    developmentArea: ['products'],
    description: "Solved software issues in transmission & powertrain systems for major OEMs",
    projects: [
      "Coordinated Common Powertrain Controller functions and ECU integration",
      "Served on ITK's Hardware-in-the-Loop advisory board"
    ],
    category: 'work',
    tileSpan: 4
  },
  {
    id: "education-1",
    period: "2015 - 2017",
    role: "MBA Student",
    company: "University of West Florida",
    location: "Florida, USA",
    developing: "Management Skills",
    developmentArea: ['competences'],
    description: "MBA in General & International Management (GPA: 3.89)",
    projects: [],
    category: 'education',
    tileSpan: 4
  },
  {
    id: "career-6",
    period: "07/2015 - 08/2018",
    role: "Project Manager/Scrum Master",
    company: "ITK Engineering GmbH",
    location: "Rülzheim",
    developing: "International Projects",
    developmentArea: ['products'],
    description: "Managed diverse national and international (US, Japan) projects (3–18 team members) across automotive and industrial sectors",
    projects: [
      "Delivered solutions ranging from battery systems to automated production platforms and vehicle modeling"
    ],
    category: 'work',
    tileSpan: 5
  },
  {
    id: "career-5",
    period: "07/2016 - 08/2018",
    role: "Team Manager Machine Learning & Artificial Intelligence",
    company: "ITK Engineering GmbH",
    location: "Rülzheim",
    developing: "ML/AI Team",
    developmentArea: ['people'],
    description: "Founded & (disciplinary) led a 15-member self-organized team focusing on team empowerment, recruiting, and talent development",
    projects: [
      "Managed parallel agile projects and introduced scalable Scrum practices",
      "Represented the company at industry networks and recruiting events"
    ],
    category: 'work',
    tileSpan: 5
  },
  {
    id: "publication-3",
    period: "2017",
    role: "Author",
    company: "ATZ (Automobiltechnische Zeitschrift)",
    location: "Publication",
    developing: "Industry Knowledge",
    developmentArea: ['competences'],
    description: "Article: 'Neue Geschäftsmodelle durch Over-the-Air-Technologien'",
    projects: [],
    category: 'publication',
    tileSpan: 4
  },
  {
    id: "publication-2",
    period: "2018 - Present",
    role: "Blogger",
    company: "Personal Blog",
    location: "Online",
    developing: "Sharing Insights",
    developmentArea: ['competences'],
    description: "Various articles on blog",
    projects: [],
    category: 'publication',
    tileSpan: 3
  },
  {
    id: "career-4",
    period: "08/2018 - 02/2020",
    role: "Release Train Engineer - Automotive OS",
    company: "Robert Bosch GmbH",
    location: "Abstatt",
    developing: "Scrum Master Team & Business Unit",
    developmentArea: ['organizations'],
    description: "Led and developed a Scrum Master team",
    projects: [
      "Organized and facilitated bi-monthly workshops (~60 participants)",
      "Managed stakeholders & drove business unit agile transformation initiatives"
    ],
    category: 'work',
    tileSpan: 4
  },
  {
    id: "publication-1",
    period: "2019",
    role: "Speaker",
    company: "Global SAFe Summit 2019",
    location: "Conference",
    developing: "Community Knowledge",
    developmentArea: ['competences'],
    description: "Speaking engagement at Global SAFe Summit",
    projects: [],
    category: 'publication',
    tileSpan: 4
  },
  {
    id: "career-2",
    period: "02/2020 - 03/2024",
    role: "Organizational Development Coach",
    company: "Robert Bosch GmbH",
    location: "Abstatt",
    developing: "Teams & Organizations",
    developmentArea: ['organizations'],
    description: "Led a team of 30 agile coaches to help build a decentralized service organization (300+ developers, 200+ products, 350+ customer projects)",
    projects: [
      "Cut red tape in global Bosch directives on leadership with central units",
      "Designed and led leadership development workshops"
    ],
    category: 'work',
    tileSpan: 5
  },
  {
    id: "social-1",
    period: "2001 - 2007, 2021 - Today",
    role: "Youth Basketball Coach",
    company: "TSV Neuenstadt Basketball",
    location: "Neuenstadt, Germany",
    developing: "Youth Athletes",
    developmentArea: ['people', 'community'],
    description: "Coaching youth basketball teams",
    projects: [
      "Technical director at TSV Neuenstadt Basketball",
      "Team captain at TSV Neuenstadt Basketball"
    ],
    category: 'personal',
    tileSpan: 3
  },
  {
    id: "career-3",
    period: "03/2021 - 11/2023",
    role: "Domain Facilitator",
    company: "Robert Bosch GmbH with Cariad SE (1500+ employees)",
    location: "Abstatt",
    developing: "Cross-organizational Teams & Leadership",
    developmentArea: ['organizations'],
    description: "Co-created and implemented processes and structures for key strategic project",
    projects: [
      "Designed and delivered executive leadership trainings and Train-the-Trainer programs on Leadership, OKRs and organizational development",
      "Drove domain and team development across Bosch, Cariad, and MHP",
      "Managed staffing for team- and org-development roles"
    ],
    category: 'work',
    tileSpan: 4
  },
  {
    id: "social-3",
    period: "Ongoing",
    role: "Mentor",
    company: "UAS Karlsruhe, UAS Ludwigshafen, Campus Founders Heilbronn",
    location: "Various locations",
    developing: "Students & Founders",
    developmentArea: ['community'],
    description: "Mentoring students and startup founders at multiple institutions",
    projects: [],
    category: 'personal',
    tileSpan: 4
  },
  {
    id: "career-1",
    period: "04/2024 - Today",
    role: "Organizational Development Expert",
    company: "Bosch Business Innovations GmbH",
    location: "Ludwigsburg",
    developing: "Startups & New Ventures",
    developmentArea: ['organizations'],
    description: "Helped establish and manage Bosch's internal Venture Building unit",
    projects: [
      "Assessed and advised startups on scalable self-organization models",
      "Mitigated organizational risks by implementing CRM and OKR frameworks",
      "Stepped into interim leadership to support scaling in a high-risk venture"
    ],
    category: 'work',
    tileSpan: 4
  },
  {
    id: "family-photo-1",
    period: "2024",
    role: "Sahara Desert",
    company: "Family Adventure",
    location: "Sahara Desert",
    developing: "Family Memories",
    developmentArea: ['personal'],
    description: "Sahara Desert",
    projects: [],
    category: 'personal',
    imageUrl: family1,
    tileSpan: 5
  },
  {
    id: "family-photo-2",
    period: "2024",
    role: "Emotions of a 4 year old",
    company: "Family Moments",
    location: "Home",
    developing: "Family Memories",
    developmentArea: ['personal'],
    description: "Emotions of a 4 year old",
    projects: [],
    category: 'personal',
    imageUrl: family2,
    tileSpan: 4
  },
  {
    id: "family-photo-3",
    period: "2024",
    role: "Same hair as dad",
    company: "Family Moments",
    location: "Home",
    developing: "Family Memories",
    developmentArea: ['personal'],
    description: "Same hair as dad",
    projects: [],
    category: 'personal',
    imageUrl: family3,
    tileSpan: 6
  },
  {
    id: "family-photo-4",
    period: "2024",
    role: "Rescuing a bug",
    company: "Family Moments",
    location: "Outdoors",
    developing: "Family Memories",
    developmentArea: ['personal'],
    description: "Rescuing a bug",
    projects: [],
    category: 'personal',
    imageUrl: family4,
    tileSpan: 5
  },
  {
    id: "family-photo-5",
    period: "2024",
    role: "Experimenta collision",
    company: "Family Outing",
    location: "Experimenta",
    developing: "Family Memories",
    developmentArea: ['personal'],
    description: "Experimenta collision",
    projects: [],
    category: 'personal',
    imageUrl: family5,
    tileSpan: 4
  },
  {
    id: "family-photo-6",
    period: "2024",
    role: "1 of 3, no idea which though",
    company: "Family Moments",
    location: "Home",
    developing: "Family Memories",
    developmentArea: ['personal'],
    description: "1 of 3, no idea which though",
    projects: [],
    category: 'personal',
    imageUrl: family6,
    tileSpan: 6
  },
  {
    id: "community-volunteers",
    period: "2024",
    role: "Volunteers",
    company: "TSV Neuenstadt Basketball",
    location: "Neuenstadt",
    developing: "Community",
    developmentArea: ['community'],
    description: "TSV Neuenstadt Basketball Volunteers",
    projects: [],
    category: 'personal',
    imageUrl: community1,
    tileSpan: 6
  },
  {
    id: "community-championship",
    period: "2024",
    role: "Championship Team",
    company: "TSV Neuenstadt Basketball",
    location: "Neuenstadt",
    developing: "Success",
    developmentArea: ['community'],
    description: "TSV Neuenstadt Basketball Team after winning the Championship in 2024",
    projects: [],
    category: 'personal',
    imageUrl: community3,
    tileSpan: 6
  },
  {
    id: "work-product-dev",
    period: "Since 2025",
    role: "Product Development",
    company: "Kevin Rassner",
    location: "Heilbronn",
    developing: "Tools & Startups",
    developmentArea: ['products'],
    description: "Developing solutions for myself and Startups",
    projects: [],
    category: 'work',
    tileSpan: 4
  },
  {
    id: "education-42",
    period: "01/2026",
    role: "42Heilbronn Student",
    company: "42 Heilbronn",
    location: "Heilbronn",
    developing: "Self-organization in Education",
    developmentArea: ['competences'],
    description: "Study self organization in education",
    projects: [],
    category: 'education',
    tileSpan: 3
  },
  {
    id: "community-voluntary",
    period: "12/2025 - 03/2026",
    role: "Voluntary help",
    company: "Various Non-Profits",
    location: "Heilbronn Area",
    developing: "Community Support",
    developmentArea: ['community'],
    description: "Technical support of various non-profits",
    projects: [],
    category: 'personal',
    tileSpan: 4
  },
];
